import script from "./ProjectPreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProjectPreview.vue?vue&type=script&lang=ts&setup=true"

import "./ProjectPreview.vue?vue&type=style&index=0&id=5cb0f1ee&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/oa-sales-user/oa-admin-web/sales-web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cb0f1ee"]])

export default __exports__